import { toastService } from 'utils';

const MESSAGE_STATUSES = [400, 409];

function handleApiError(response: any) {
  if (!response || !MESSAGE_STATUSES.includes(response.status)) {
    return;
  }

  const message = response.data?.message;

  if (!message) {
    return;
  }

  toastService.error(message);
}

export { handleApiError };
